import React from "react";
import ReactDOM from "react-dom/client";

import "./styles.css";
import "./index.css";

import Alert from "./components/Alert";

import App from "./App";
import Csv from "./Csv";

/* uncomment for testing locally
window.shareyourstorySettings = {
	id: "csv", // submit, csv
};*/

let element = (
	<Alert data={{ type: "error", text: "An error has occurred." }} />
);

if (window.shareyourstorySettings) {
	const { id } = window.shareyourstorySettings;
	element = id === "submit" ? <App /> : <Csv />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode>{element}</React.StrictMode>);
